// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
// https://listest.stc.vn:8643/login
// http://lienlacdientu.vn
export const environment = {
  production: false,
  baseUrl: 'https://lienlacdientu.vn',
  webUrl: 'https://lienlacdientu.vn',
  jitsiUrl: 'https://meet.pmr.vn/',
  apiLmsUrl: 'https://apilms.lienlacdientu.vn',
  lmsUrl: 'https://lms.mschool.edu.vn',
  firebase: {
    apiKey: 'AIzaSyAl5SRBmta6_jbc9L8g40zerWRAg06pAdo',
    authDomain: 'mschool-de76f.firebaseapp.com',
    databaseURL: 'https://mschool-de76f-default-rtdb.asia-southeast1.firebasedatabase.app',
    projectId: 'mschool-de76f',
    storageBucket: 'mschool-de76f.appspot.com',
    messagingSenderId: '825687385563',
    appId: '1:825687385563:web:4c89cfc2570bfccfb9b3fe'
  }
};

